import {
  Calendar,
  CheckSquare,
  CircleDot,
  Mail,
  MapPin,
  PenLine,
  Phone,
  Signature,
  Type,
  User,
} from 'lucide-react';

/**
 * The builder's field palette — mirrors OtterWaiver's catalog (signature /
 * initials, autofilled identity fields, standard inputs) mapped onto the
 * backend `SignFieldKind` enum. Default sizes are percentages of the page.
 */
export const FIELD_TYPES = [
  {
    kind: 'signature',
    label: 'Signature',
    icon: Signature,
    group: 'Signature fields',
    defaults: { posWidth: 22, posHeight: 5 },
  },
  {
    kind: 'initial',
    label: 'Initials',
    icon: PenLine,
    group: 'Signature fields',
    defaults: { posWidth: 9, posHeight: 5 },
  },
  {
    kind: 'name',
    label: 'Full name',
    icon: User,
    group: 'Auto-filled fields',
    defaults: { posWidth: 18, posHeight: 3 },
  },
  {
    kind: 'email',
    label: 'Email',
    icon: Mail,
    group: 'Auto-filled fields',
    defaults: { posWidth: 18, posHeight: 3 },
  },
  {
    kind: 'phone',
    label: 'Phone',
    icon: Phone,
    group: 'Auto-filled fields',
    defaults: { posWidth: 14, posHeight: 3 },
  },
  {
    kind: 'date_signed',
    label: 'Date signed',
    icon: Calendar,
    group: 'Auto-filled fields',
    defaults: { posWidth: 12, posHeight: 3 },
  },
  {
    kind: 'text',
    label: 'Text',
    icon: Type,
    group: 'Standard fields',
    defaults: { posWidth: 20, posHeight: 3.2 },
  },
  {
    kind: 'address',
    label: 'Address',
    icon: MapPin,
    group: 'Standard fields',
    defaults: { posWidth: 26, posHeight: 3.2 },
  },
  {
    kind: 'checkbox',
    label: 'Checkbox',
    icon: CheckSquare,
    group: 'Standard fields',
    defaults: { posWidth: 2.6, posHeight: 2 },
  },
  {
    kind: 'radio',
    label: 'Radio button',
    icon: CircleDot,
    group: 'Standard fields',
    defaults: { posWidth: 2.6, posHeight: 2 },
  },
];

export const fieldType = (kind) => FIELD_TYPES.find((t) => t.kind === kind);

/** Caption shown on a field box: the author's own wording, else the type name. */
export const fieldLabelText = (field) =>
  field.label || fieldType(field.kind)?.label || field.kind;

/**
 * Whether that caption is drawn. Fields default to labelled — `?? true` also
 * covers rows written before `show_label` existed.
 */
export const isLabelVisible = (field) => field.showLabel ?? true;

/** Kinds the signer actively fills in (everything else is auto-filled). */
export const INPUT_KINDS = new Set(['signature', 'initial', 'text', 'address', 'checkbox', 'radio']);

/** Per-recipient accent colors (sequence-indexed), OtterWaiver style. */
export const SIGNER_COLORS = ['#2563eb', '#16a34a', '#ea580c', '#9333ea', '#0d9488'];

export const signerColor = (sequence) => SIGNER_COLORS[sequence % SIGNER_COLORS.length];
